import { useEffect, useState } from "react";
import { api } from "../../lib/api";

const pad = (n) => String(n).padStart(2, "0");

export const useLaunchState = () => {
  const [cfg, setCfg] = useState(null);
  const [t, setT] = useState(Date.now());
  useEffect(() => { api.get("/public/config").then((r) => setCfg(r.data)).catch(() => setCfg({})); }, []);
  useEffect(() => { const i = setInterval(() => setT(Date.now()), 1000); return () => clearInterval(i); }, []);
  if (!cfg) return { loading: true };
  const diff = cfg.launch_at ? new Date(cfg.launch_at).getTime() - t : 0;
  return { loading: false, locked: !!cfg.launch_at && !cfg.product_launched && diff > 0, diff, launchAt: cfg.launch_at };
};

export const Countdown = ({ diff }) => {
  const s = Math.max(0, Math.floor(diff / 1000));
  const parts = [["Days", Math.floor(s / 86400)], ["Hours", pad(Math.floor((s % 86400) / 3600))], ["Mins", pad(Math.floor((s % 3600) / 60))], ["Secs", pad(s % 60)]];
  return (
    <div className="flex gap-2 sm:gap-3 justify-center" data-testid="launch-countdown">
      {parts.map(([l, v]) => (
        <div key={l} className="card-surface px-3 sm:px-5 py-3 min-w-[70px] sm:min-w-[96px] text-center" data-testid={`countdown-${l.toLowerCase()}`}>
          <p className="font-display text-3xl sm:text-5xl font-black tabular-nums">{v}</p>
          <p className="text-[10px] uppercase tracking-widest text-[#7C8A7C]">{l}</p>
        </div>
      ))}
    </div>
  );
};

export const LaunchGate = ({ diff, launchAt }) => (
  <div className="relative min-h-screen overflow-hidden noise flex items-center justify-center px-5 bg-[#080A08]" data-testid="launch-gate">
    <img src="https://images.unsplash.com/photo-1512719994953-eabf50895df7?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000" alt="" className="absolute inset-0 w-full h-full object-cover opacity-20" />
    <div className="absolute inset-0 bg-gradient-to-b from-[#080A08]/70 via-[#080A08]/90 to-[#080A08]" />
    <div className="absolute inset-0 grid-bg opacity-50" />
    <div className="relative text-center max-w-2xl">
      <div><span className="inline-block bg-white rounded-xl px-3 py-1.5 border border-[#B7FF3C]/30"><img src="/logo.png" alt="CricAnalyze" className="h-14 w-auto" /></span></div>
      <p className="rise mt-8 inline-flex items-center gap-2 eyebrow px-3 py-1.5 rounded-full border border-[#B7FF3C]/30 bg-[#B7FF3C]/5"><span className="w-1.5 h-1.5 rounded-full bg-[#B7FF3C] animate-pulse" /> The Future of Cricket Coaching</p>
      <h1 className="rise mt-6 text-5xl sm:text-6xl lg:text-7xl font-black uppercase tracking-tight leading-[0.92]">Analyze. Improve.<br /><span className="text-[#B7FF3C]">Play Better.</span></h1>
      <p className="rise mt-5 text-[#A3ADA3]">The CricAnalyze waitlist opens soon.</p>
      <p className="eyebrow !text-[#7C8A7C] mt-8 mb-3" data-testid="launch-date">Opening {new Date(launchAt).toLocaleString(undefined, { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" })}</p>
      <Countdown diff={diff} />
      <p className="mt-12 text-xs text-[#5E6B5E]">By Buddy Innovations &amp; Technologies</p>
    </div>
  </div>
);
